export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    lp_name: '',
    deletable: true,
    appliedThemeId: null,
    pageId: null,
    backgroundColor: 'inherit',
    data: {},
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '20489355-c46f-4992-a3de-5b799eeb268d',
        lp_name: '',
        deletable: true,
        tokens: {},
        mergeTag: null,
        textAlign: 'center',
        width: '100%',
        stackOnMobile: true,
        borderRadius: '12px 12px 12px 12px',
        appliedThemeId: null,
        position: 'relative',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        positionTopActive: true,
        positionLeftActive: false,
        positionRightActive: true,
        positionBottomActive: false,
        centerHorizontally: false,
        centerVertically: false,
        flexDirection: 'column',
        mobileFlexDirection: 'column',
        backgroundColor: '#030712FF',
        overflow: 'hidden',
        shadow: 'none',
        blur: '0px',
        backgroundDarken: false,
        horizontalAlign: 'left',
        verticalAlign: 'align_center',
        width_max: '100%',
        mobilePadding: '24px 24px 24px 24px',
        padding: '24px 24px 24px 24px',
        margin: '0px 0px 0px 0px',
        gap: '12px',
        borderWidth: '1px',
        borderColor: '#E5E7EB',
        borderStyle: 'solid',
        flexWrap: 'nowrap',
        zIndex: 'auto',
      },
      content: [
        {
          type: 'container',
          attrs: {
            id: '6b81eba7-8e57-42ee-b61c-39b5046f7c76',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: '#03071200',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '4px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '51b66b0f-d024-4f65-aeb6-0ed63cefd9af',
                lp_name: 'Message',
                deletable: true,
                textAlign: 'left',
                tokens: {},
                mergeTag: 'testimonial.message',
                width: 'fit-content',
                maxWidth: '100%',
                appliedThemeId: null,
                backgroundColor: 'transparent',
                borderRadius: '0px',
                borderWidth: '0px',
                borderColor: 'inherit',
                borderStyle: 'none',
                lineClampClass: '',
                padding: '0px 0px 0px 0px',
                mobilePadding: '0px 0px 0px 0px',
                lineHeight: '120%',
                mobileLineHeight: '120%',
                margin: null,
                postAuthors: [],
                postAuthorsTruncateListEnabled: false,
                postAuthorsImagesEnabled: true,
                postAuthorsTextEnabled: true,
                postAuthorsImagesFill: 'inherit',
                postAuthorsByLine: '',
                postTimestampDisplay: 'short_date',
                postReadTimeSuffix: 'min read',
                postTagsTruncateListEnabled: true,
                postTagsGap: '4px',
                postPaidContentGap: '4px',
                postPaidContentIconSize: 16,
                postPaidIconFill: '#030712',
                postPaidText: '',
                postAuthorsGap: '4px',
                postAuthorsImageSize: '24px',
                textTransform: 'none',
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        mobileFontSize: '14px',
                        fontSize: '14px',
                        fontWeight: '400',
                        fontGradient: null,
                        fontFamily: 'Inter',
                        color: '#FFFFFF',
                        textTransform: null,
                        tokens: {
                          color: 'text_on_background_color',
                        },
                        appliedThemeId: null,
                        hoverTextColor: null,
                        hoverDecorationLine: null,
                        hoverDecorationColor: null,
                      },
                    },
                  ],
                  text: '“The newsletters are a perfect mix of education and entertainment. They brighten up my inbox every week!”',
                },
              ],
            },
          ],
        },
        {
          type: 'container',
          attrs: {
            id: '33450daa-5fae-4031-aa75-827dd4acbdf4',
            lp_name: '',
            deletable: true,
            tokens: {},
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'row',
            mobileFlexDirection: 'row',
            backgroundColor: '#03071200',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_start',
            height: 'auto',
            width_max: '100%',
            mobilePadding: '0px 0px 0px 0px',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: '14px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'wrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'container',
              attrs: {
                id: 'f883a38e-c05a-43ac-9650-214783f0b2af',
                lp_name: '',
                deletable: true,
                tokens: {},
                mergeTag: null,
                textAlign: 'center',
                width: 'auto',
                stackOnMobile: true,
                borderRadius: '0px 0px 0px 0px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: '#03071200',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_start',
                height: 'auto',
                width_max: null,
                mobilePadding: '0px 0px 0px 0px',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '4px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'image',
                  attrs: {
                    id: '7ce360d3-9caf-4d26-9f97-fa56943fea65',
                    lp_name: '',
                    tokens: {},
                    mergeTag: 'testimonial.image',
                    width: 40,
                    boxShadow: 'none',
                    appliedThemeId: null,
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    positionTopActive: true,
                    positionLeftActive: false,
                    positionRightActive: true,
                    positionBottomActive: false,
                    centerHorizontally: false,
                    centerVertically: false,
                    url: '',
                    open_in_new_tab: false,
                    internal_link: false,
                    padding: '0px',
                    target: null,
                    captionUrl: '',
                    captionTarget: null,
                    src: 'https://beehiiv-images-production.s3.us-east-1.amazonaws.com/dream_builder/Kyra+Singh.jpg',
                    title: '',
                    alt: 'Kyra Singh',
                    height: 40,
                    align: 'center',
                    captionAlign: 'center',
                    borderWidth: '0px',
                    objectFit: 'cover',
                    aspectRatio: 1,
                    borderRadius: '43px 43px 43px 43px',
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    isFullWidth: false,
                  },
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: '811a5b58-110a-4f49-904e-086b2ef4ef1e',
                lp_name: '',
                deletable: true,
                tokens: {},
                mergeTag: null,
                textAlign: 'center',
                width: 'auto',
                stackOnMobile: true,
                borderRadius: '0px 0px 0px 0px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: '#03071200',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_start',
                width_max: null,
                mobilePadding: '0px 0px 0px 0px',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '0px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '07d5b554-5bbd-47d4-a323-78661022564c',
                    lp_name: 'Name',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {},
                    mergeTag: 'testimonial.name',
                    width: '100%',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'inherit',
                    borderStyle: 'none',
                    lineClampClass: '',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: false,
                    postAuthorsImagesEnabled: true,
                    postAuthorsTextEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                    textTransform: 'none',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '12px',
                            fontSize: '12px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#FFFFFF',
                            textTransform: null,
                            tokens: {
                              color: 'text_on_background_color',
                            },
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                        {
                          type: 'bold',
                        },
                      ],
                      text: 'Kyra Singh',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'abcaba43-2290-479a-969d-80b1399930c1',
                    lp_name: 'Description',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {},
                    mergeTag: 'testimonial.description',
                    width: '100%',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'inherit',
                    borderStyle: 'none',
                    lineClampClass: '',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: false,
                    postAuthorsImagesEnabled: true,
                    postAuthorsTextEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                    textTransform: 'none',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '12px',
                            fontSize: '12px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#FFFFFF',
                            textTransform: null,
                            tokens: {
                              color: 'text_on_background_color',
                            },
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: 'Marketing Professional',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
